import React from 'react';
import Typography from '../../components/Typography/Typography.jsx';
import styles from '../rjsf.module.css';

/** Renders the title for an object/array field: a heading followed by a divider. */
const TitleField = ({ id, title, required }) => {
  if (!title) {
    return null;
  }
  return (
    <div id={id} className={styles.titleField}>
      <Typography variant="h5" style={{ marginBottom: 8 }}>
        {title}
        {required && ' *'}
      </Typography>
      <hr className={styles.titleFieldDivider} />
    </div>
  );
};

export default TitleField;
